export enum BedEnum {
  DOUBLE = "double",
  TWIN = "twin",
}

export enum BookingTypeEnum {
  BOOKING = "booking",
  QUOTE = "quote",
}

export enum ButtonActionEnum {
  BUTTON = "button",
  RESET = "reset",
  SUBMIT = "submit",
}

export enum DialingCodeEnum {
  UK = "United Kingdom",
  US = "United States",
  AUSTRALIA = "Australia",
  CANADA = "Canada",
  FINLAND = "Finland",
  FRANCE = "France",
  GERMANY = "Germany",
  IRELAND = "Ireland",
  INDIA = "India",
  ICELAND = "Iceland",
  ITALY = "Italy",
  NETHERLANDS = "Netherlands",
  NORWAY = "Norway",
  PORTUGAL = "Portugal",
  SOUTH_AFRICA = "South Africa",
  SPAIN = "Spain",
  SWEDEN = "Sweden",
  SWITZERLAND = "Switzerland",
  TURKEY = "Turkey",
  UAE = "United Arab Emirates",
}

export enum CreditCardTypeEnum {
  MASTERCARD = "MCRD",
  VISA = "VISA",
  AMERICAN_EXPRESS = "AMEX",
}

export enum DayFillEnum {
  NONE = "none",
  MONTH = "month",
  WEEK = "week",
}

export enum DayFormatEnum {
  SHORT = "short",
  MEDIUM = "medium",
  LONG = "long",
}

export enum IconEnum {
  BED = "bed",
  BED_DOUBLE = "bed-double",
  BED_SINGLE = "bed-single",
  BED_TWIN = "bed-twin",
  CIRCLE_STAR = "circle-star",
  CHECK = "check",
  GOLF_BALL_TEE = "golf-ball-tee",
  USER = "user",
  MOON = "moon",
  CALENDAR = "calendar",
  PLAIN = "plain",
  CIRCLE_EXCLAMATION = "circle-exclamation",
}

export enum ImageFetchPriorityEnum {
  AUTO = "auto",
  HIGH = "high",
  LOW = "low",
}

export enum ImageLoadingEnum {
  EAGER = "eager",
  LAZY = "lazy",
}

export enum ImageProviderEnum {
  BUCKET = "bucket",
  CLOUDINARY = "cloudinary",
  CONTENTFUL = "contentful",
  EXTERNAL = "external",
}

export enum ImageVariantEnum {
  BANNER = "banner",
  CARD = "card",
  CARD2X = "card2x",
  FULLWIDTH = "fullwidth",
  GRID = "grid",
  HERO = "hero",
  LIGHTBOX = "lightbox",
  NONE = "none",
  PRIMARY = "primary",
  RADIO = "radio",
  SECONDARY = "secondary",
  SEARCH = "search",
  SUMMARY = "summary",
  THUMBNAIL = "thumbnail",
}

export enum LegendPositionEnum {
  CENTER = "center",
  RIGHT = "right",
}

export enum ModeEnum {
  READ = "read",
  READWRITE = "readwrite",
  WRITE = "write",
}

export enum SectionRoleEnum {
  BANNER = "banner",
  REGION = "region",
}

export enum SizeEnum {
  X_SMALL = "x-small",
  SMALL = "small",
  STANDARD = "standard",
  LARGE = "large",
  X_LARGE = "x-large",
  XX_LARGE = "xx-large",
  X3_LARGE = "x3-large",
}

export enum TooltipPlacement {
  BOTTOM = "bottom",
  BOTTOM_RIGHT = "bottom-right",
  TOP = "top",
}
